// src/components/StaffSection.jsx
import React, { useRef, useState, useEffect } from 'react';
import { FiUser } from 'react-icons/fi';
import './StaffSection.css';

// YKS kadrosu resimleri
import emelDurmaz from '../teachers/emelDurmaz.png';
import gulsenCakmakOzturk from '../teachers/gulsenCakmakOzturk.png';
import fatihTurkmen from '../teachers/fatihTurkmen.png';
import aliGulhanTetik from '../teachers/aliGulhanTetik.png';
import mahmutAltun from '../teachers/mahmutAltun.png';
import onurTun from '../teachers/onurTun.png';
import erdoganGurbuz from '../teachers/erdoganGurbuz.png';
import hazalBektas from '../teachers/hazalBektas.png';
import gulcanKoyuncu from '../teachers/gulcanKoyuncu.png';
import cansuBesteDemirci from '../teachers/cansuBesteDemirci.png';
import guldenDokmetepe from '../teachers/guldenDokmetepe.png'
import fatmaSimsek from '../teachers/fatmaSimsek.png'
import saniyeSerbes from '../teachers/saniyeSerbes.png'
import ezginurDasdan from '../teachers/ezginurDasdan.png'
import dogaDokgoz from '../teachers/dogaDokgoz.png'


// İlk ve Ortaokul kadro resimleri
import adileDokak from '../teachers/adileDokak.png';
import asliTatar from '../teachers/asliTatar.png';
import burcuDurak from '../teachers/burcuDurak.png';
import damlaCelik from '../teachers/damlaCelik.png';
import elvanColakoglu from '../teachers/elvanColakoglu.png';
import hakanTalih from '../teachers/hakanTalih.png';
import merveGole from '../teachers/merveGole.png';
import seherAn from '../teachers/seherAn.png';
import seldaDemirelOzugul from '../teachers/seldaDemirelOzugul.png';
import sinemOzden from '../teachers/sinemOzden.png';
import yagmurAdibelli from '../teachers/yagmurAdibelli.png';
import kadirSahin from '../teachers/kadirSahin.png';
import niluferEroglu from '../teachers/niluferEroglu.png';
import merveIsik from '../teachers/merveIsik.png';
import atilimTemur from '../teachers/atilimTemur.png';
import mehmetUgurEkinci from '../teachers/mehmetUgurEkinci.png';
import merveYildirim from '../teachers/merveYildirim.png';
import fatmaYildiz from '../teachers/fatmaYildiz.png';
import erdalGuler from '../teachers/erdalGuler.png';


// Anaokulu kadrosu resimleri
import tansuGocmen from '../teachers/tansuGocmen.png';
import kubraOzyurt from '../teachers/kubraOzyurt.png';


import cerenIspir from '../teachers/cerenİspir.jpeg';
import inciDurusoy from '../teachers/inciDurusoy.jpeg';
import cerenOzcan from '../teachers/cerenOzcan.jpeg';
import ursulaMoscol from '../teachers/ursulaMoscol.jpeg';
import gulcinYazici from '../teachers/gulcinYazici.jpeg';
import fundaYilmaz from '../teachers/fundaYilmaz.jpeg';
import fatmaNurErdemir from '../teachers/fatmanurErdemir.jpeg';
import eylulSerenYilmaz from '../teachers/eylulSerenYilmaz.jpeg';
import sibelImahanoglu from '../teachers/sibelImahanoglu.jpeg';

import cerenOksuz from '../teachers/cerenOksuz.jpeg';
import cerenEr from '../teachers/cerenEr.jpeg';
import selinCalik from '../teachers/selinCalik.jpeg';
import bahriyeBaser from '../teachers/bahriyeBaser.jpeg';
import merveCoskun from '../teachers/merveCoskun.jpeg';
import deryaYildiz from '../teachers/deryaYildiz.jpeg';
import merveBaltan from '../teachers/merveBaltan.jpeg';
import gulnihalKose from '../teachers/gulnihalKose.jpeg';
import ahmetEsin from '../teachers/ahmetEsin.jpeg';
import gullerKirmizigul from '../teachers/gullerKirmizigul.jpeg';
import merveYazar from '../teachers/merveYazar.jpeg';
import aysenurAkdenizErturk from '../teachers/aysenurAkdenizErturk.jpeg';
import meryemAdiguzel from '../teachers/meryemAdiguzel.jpeg';

// YKS kadrosu verisi
const yksStaff = [
  { id: 101, img: onurTun,            name: 'Onur Tün',              title: 'Kurs Müdürü' },
  { id: 103, img: emelDurmaz,       name: 'Emel Durmaz',         title: 'Psikolojik Danışmanlık ve Rehberlik Öğretmeni' },
  { id: 121, img: cerenOksuz, name: 'Ceren Öksüz', title: 'PDR' },
  { id: 124, img: cerenEr, name: 'Ceren Er', title: 'PDR' },
  { id: 106, img: gulsenCakmakOzturk,   name: 'Gülşen Çakmak Öztürk',    title: 'Fen Bilimleri Öğretmeni' },
  { id: 125, img: selinCalik, name: 'Selin Çalık', title: 'Fen Bilimleri Öğretmeni' },
  { id: 119, img: dogaDokgoz,       name: 'Doğa Doksöz',         title: 'Matematik Öğretmeni' },
  { id: 107, img: fatihTurkmen,         name: 'Fatih Türkmen',           title: 'Matematik Öğretmeni' },
  { id: 108, img: erdoganGurbuz,         name: 'Erdoğan Gürbüz',           title: 'Matematik Öğretmeni' },

  { id: 112, img: aliGulhanTetik,       name: 'Ali Gülhan Tetik',         title: 'Fizik Öğretmeni' },
  { id: 113, img: mahmutAltun,       name: 'Mahmut Altun',         title: 'Kimya Öğretmeni' },
  { id: 111, img: cansuBesteDemirci,       name: 'Cansu Beste Demirci',         title: 'Biyoloji Öğretmeni' },
  { id: 123, img: bahriyeBaser, name: 'Bahriye Başer', title: 'Biyoloji Öğretmeni' },
  { id: 109, img: hazalBektas,       name: 'Hazal Bektaş',         title: 'Türk Dili ve Edebiyatı Öğretmeni' },
  { id: 110, img: gulcanKoyuncu,       name: 'Gülcan Koyuncu',         title: 'Türkçe Öğretmeni' },
  { id: 117, img: fatmaSimsek,       name: 'Fatma Şimşek',         title: 'Coğrafya Öğretmeni' },
  { id: 122, img: merveCoskun, name: 'Merve Coşkun', title: 'Tarih Öğretmeni' },
  { id: 116, img: guldenDokmetepe,       name: 'Gülden Dökmetepe',         title: 'Grafik Tasarım Uzmanı' },
  { id: 120, img: ezginurDasdan,       name: 'Ezginur Daşdan',         title: 'Sekreter' },
  { id: 118, img: saniyeSerbes,       name: 'Saniye Serbes',         title: 'Personel' },


];

// ilkokul
const staff = [
  { id: 28, img: cerenIspir, name: 'Ceren İspir', title: 'İlkokul Müdürü' },
  { id: 1,  img: seherAn,            name: 'Seher An',             title: 'Ortaokul Müdürü' },
  { id: 29, img: deryaYildiz, name: 'Derya Yıldız', title: 'İlkokulu Rehber Öğretmeni' },
  { id: 33, img: merveBaltan, name: 'Merve Baltan', title: 'Ortaokul Rehber Öğretmeni' },
  { id: 4,  img: elvanColakoglu,     name: 'Elvan Çolakoğlu',       title: 'Sınıf Öğretmeni' },
  { id: 5,  img: damlaCelik,         name: 'Damla Çelik',           title: 'Sınıf Öğretmeni' },
  { id: 26,  img: erdalGuler,         name: 'Erdal Güler',           title: 'Sınıf Öğretmeni' },
  { id: 31, img: gulnihalKose, name: 'Gülnihal Köse', title: 'Sınıf Öğretmeni' },

  { id: 6,  img: yagmurAdibelli,     name: 'Yağmur Adibelli',       title: 'Türkçe Öğretmeni' },
  { id: 7,  img: sinemOzden,         name: 'Sinem Özden',           title: 'Matematik Öğretmeni' },
  { id: 32, img: ahmetEsin, name: 'Ahmet Esin', title: 'Matematik Öğretmeni' },
  { id: 8,  img: burcuDurak,         name: 'Burcu Durak',           title: 'Fen Bilimleri Öğretmeni' },
  { id: 9,  img: adileDokak,         name: 'Adile Dokak',           title: 'Sosyal Bilgiler Öğretmeni' },
  { id: 25, img: mehmetUgurEkinci,   name: 'Mehmet Uğur Ekinci',    title: 'İngilizce Öğretmeni' },
  { id: 17, img: merveYildirim,   name: 'Merve Yıldırım',    title: 'İngilizce Öğretmeni' },
  { id: 30, img: gullerKirmizigul, name: 'Güller Kırmızıgül', title: 'İngilizce Öğretmeni' },

  { id: 10, img: seldaDemirelOzugul, name: 'Selda Demirel Özgül',   title: 'Görsel Sanatlar Öğretmeni' },
  { id: 22, img: atilimTemur,        name: 'Atılım Temur',          title: 'Drama Öğretmeni' },
  { id: 13, img: merveGole,          name: 'Merve Göle',            title: 'Beden Eğitimi Öğretmeni' },
  { id: 14, img: hakanTalih,         name: 'Hakan Talih',           title: 'Müzik Öğretmeni' },
  { id: 34, img: merveYazar, name: 'Merve Yazar', title: 'Din Kültürü ve Ahlak Bilgisi Öğretmeni' },
  { id: 18, img: merveIsik,          name: 'Merve Işık',            title: 'Danışma & Halkla İlişkiler' },
  { id: 21, img: kadirSahin,       name: 'Kadir Şahin',         title: 'Personel' },
  { id: 19, img: niluferEroglu,      name: 'Nilüfer Eroğlu',        title: 'Personel' },
  { id: 27, img: fatmaYildiz,        name: 'Fatma Yıldız',          title: 'Personel' },


];

// Anaokulu kadrosu
const kindergartenStaff = [
  { id: 21, img: inciDurusoy, name: 'İnci Durusoy', title: 'Sokullu Anaokulu Müdürü' },
  { id: 19, img: kubraOzyurt,         name: 'Kübra Özyurt', title: 'Eğitim Koordinatörü' },
  { id: 22, img: cerenOzcan, name: 'Ceren Özcan', title: 'Psikolojik Danışmanlık ve Rehberlik' },
  { id: 23, img: ursulaMoscol, name: 'Ursula Moscol', title: 'İngilizce Öğretmeni' },
  { id: 13, img: tansuGocmen,        name: 'Tansu Göçmen',         title: 'Okul Öncesi Öğretmeni' },
  { id: 24, img: aysenurAkdenizErturk, name: 'Ayşenur Akdeniz Ertürk', title: 'Okul Öncesi Öğretmeni' },
  { id: 25, img: gulcinYazici, name: 'Gülçin Yazıcı', title: 'Okul Öncesi Öğretmeni' },
  { id: 26, img: fundaYilmaz, name: 'Funda Yılmaz', title: 'Okul Öncesi Öğretmeni' },
  { id: 27, img: fatmaNurErdemir, name: 'Fatma Nur Erdemir', title: 'Okul Öncesi Öğretmeni' },
  { id: 29, img: eylulSerenYilmaz, name: 'Eylül Seren Yılmaz', title: 'Okul Öncesi Öğretmeni' },
  { id: 30, img: sibelImahanoglu, name: 'Sibel İmahanoğlu', title: 'Okul Öncesi Öğretmeni' },
  { id: 9, img: asliTatar,          name: 'Aslı Tatar',            title: 'Personel' },
  { id: 28, img: meryemAdiguzel, name: 'Meryem Adıgüzel', title: 'Personel' },

];

function StaffCarousel({ title, staffList, itemsPerPage = 5 }) {
  const carouselRef = useRef(null);
  const [activePage, setActivePage] = useState(0);
  const pageCount = Math.max(1, Math.ceil(staffList.length / itemsPerPage));

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;
    const onScroll = () => {
      const style = getComputedStyle(el);
      const gap = parseInt(style.columnGap, 10) || 0;
      const cardWidth = el.firstChild.offsetWidth + gap;
      const newPage = Math.min(
        pageCount - 1,
        Math.round(el.scrollLeft / (cardWidth * itemsPerPage))
      );
      setActivePage(newPage);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [itemsPerPage, pageCount]);

  const scrollToPage = (page) => {
    const el = carouselRef.current;
    const style = getComputedStyle(el);
    const gap = parseInt(style.columnGap, 10) || 0;
    const cardWidth = el.firstChild.offsetWidth + gap;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    const targetLeft = Math.min(page * itemsPerPage * cardWidth, maxScrollLeft);

    el.scrollTo({ left: targetLeft, behavior: 'smooth' });
    setActivePage(page);
    setTimeout(() => setActivePage(page), 300);
  };

  return (
    <section className="staff-section">
      <h2>{title}</h2>
      <div className="staff-carousel" ref={carouselRef}>
        {staffList.map((m) => (
          <div key={`${m.name}-${m.title}`} className="staff-item">
            {m.img ? (
              <img src={m.img} alt={m.name} />
            ) : (
              <div className="staff-photo-placeholder" aria-hidden="true">
                <FiUser size={72} strokeWidth={1.25} />
              </div>
            )}
            <h3>{m.name}</h3>
            <p>{m.title}</p>
          </div>
        ))}
      </div>
      <div className="dots">
        {Array.from({ length: pageCount }).map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === activePage ? 'active' : ''}`}
            onClick={() => scrollToPage(idx)}
          />
        ))}
      </div>
    </section>
  );
}

export default function StaffSection() {
  return (
    <>
      <StaffCarousel title="Anaokulu Kadromuz" staffList={kindergartenStaff} itemsPerPage={4} />
      <StaffCarousel title="İlkokul ve Ortaokul Kadromuz" staffList={staff} itemsPerPage={5} />
      <StaffCarousel title="VIP Kurs Kadromuz" staffList={yksStaff} itemsPerPage={3} />

    </>
  );
}
